// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ShopArticleTaxResourceViewModel from '../../../../viewModel/resource/ShopArticleTaxResourceViewModel';
import ShopArticleTaxResourceDTO from '../../dto/resource/ShopArticleTaxResourceDTO';

export default abstract class ShopArticleTaxResourceModel extends BaseModel<ShopArticleTaxResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get shortName() { return this.dto.shortName; }
  set shortName(value) { this.dto.shortName = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.shortName = qs.shortname;
    this.dto.name = qs.name;
  }
}
